import { useState } from "react";

// URLSearchParams returns an iterator of decoded [key,value] tuples
// This converts to standard js object
const paramsToObject = entries => {
    const result = {};
    for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        result[key] = value;
    }
    return result;
};

const getUrlSearchParams = () => {
    return new URLSearchParams(window.location.search);
};

/**
 * useUrlSearchParams is used to simplify interacting with URL search params
 * @returns urlSearchParams: simple object to interface with
 * @returns setUrlSearchParam: sets UrlParam in URL Bar, which in turn updates URLSearchParams
 */
export const useUrlSearchParams = () => {
    const [urlSearchParams, setUrlSearchParams] = useState(
        getUrlSearchParams()
    );

    const setUrlSearchParam = ({ key, value }) => {
        if (!key) {
            console.warn(
                `You must provide a key to setUrlSearchParam key: ${key}`
            );
            return false;
        }

        const usp = getUrlSearchParams();
        usp.set([key], value);
        window.history.replaceState({}, "", `${location.pathname}?${usp}`);
        setUrlSearchParams(usp);
    };

    return {
        urlSearchParams: paramsToObject(urlSearchParams.entries()),
        setUrlSearchParam
    };
};
